function injectStyle (ssrContext) {
  require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-8e6d55de\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./OptionsMenuSelect.vue")
}
var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./OptionsMenuSelect.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-8e6d55de\"}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./OptionsMenuSelect.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8e6d55de",
  /* moduleIdentifier (server only) */
  null
)

/* customBlocks */
var customBlock = require("!!@kazupon/vue-i18n-loader!yaml-loader!../../node_modules/vue-loader/lib/selector?type=customBlocks&index=0!./OptionsMenuSelect.vue")
if (typeof customBlock === "function") {customBlock(Component)}


module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/OptionsMenuSelect.vue
// module id = 134
// module chunks = 1